import React from 'react';
import { useTranslation } from 'react-i18next';

import { NumberInput as Component, type NumberInputProps, type NumberInputTranslations } from '@/js/libs/ui/src/V2';

export const NumberInput = React.memo(
  React.forwardRef<HTMLInputElement, NumberInputProps>(function NumberInput({ translations, ...props }, ref) {
    const [t] = useTranslation(['backend', 'common']);

    const mergedTranslations = React.useMemo<NumberInputTranslations>(
      () => ({
        value: t('common:VALUE_LOWERCASE'),
      }),
      [t],
    );

    return <Component translations={mergedTranslations} ref={ref} {...props} />;
  }),
);
